const SESSION_KEY = 'assisted_login_token';

export function readAssistedLoginSessionToken(): string | null {
  if (typeof window === 'undefined') return null;
  return sessionStorage.getItem(SESSION_KEY);
}

export function storeAssistedLoginSessionToken(token: string): void {
  sessionStorage.setItem(SESSION_KEY, token);
}

export function clearAssistedLoginSessionToken(): boolean {
  if (typeof window === 'undefined') return false;
  const existed = sessionStorage.getItem(SESSION_KEY) != null;
  sessionStorage.removeItem(SESSION_KEY);
  return existed;
}

export function hasAssistedLoginSessionToken(): boolean {
  return readAssistedLoginSessionToken() != null;
}
